var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85993 13.3217C9.87664 13.3431 9.89798 13.3603 9.92235 13.3722C9.94671 13.3841 9.97346 13.3902 10.0006 13.3902C10.0277 13.3902 10.0544 13.3841 10.0788 13.3722C10.1031 13.3603 10.1245 13.3431 10.1412 13.3217L12.6412 10.1588C12.7327 10.0427 12.6501 9.87082 12.5006 9.87082H10.8465V2.31724C10.8465 2.21903 10.7662 2.13867 10.668 2.13867H9.32868C9.23047 2.13867 9.15011 2.21903 9.15011 2.31724V9.86858H7.50056C7.35101 9.86858 7.26842 10.0405 7.35993 10.1565L9.85993 13.3217ZM18.1702 12.5405H16.8309C16.7327 12.5405 16.6523 12.6208 16.6523 12.719V16.1565H3.34877V12.719C3.34877 12.6208 3.26842 12.5405 3.1702 12.5405H1.83092C1.7327 12.5405 1.65234 12.6208 1.65234 12.719V17.1387C1.65234 17.5338 1.97154 17.853 2.36663 17.853H17.6345C18.0296 17.853 18.3488 17.5338 18.3488 17.1387V12.719C18.3488 12.6208 18.2684 12.5405 18.1702 12.5405Z",
    fill: "#096DD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.19ece121168f20eeb312e43b306b730b.svg";
export { ForwardRef as ReactComponent };